import React, { useContext, useRef } from "react";
import "./SlotGamePlayPageStyle.scss";
import { slotGamePlayTextContent } from "./constant/index";
import { slotGamesInfoTextContent } from "../SlotGameInfo/constant/index";
import MainLayout from "../../components/MainLayout";
import GameDetailsListSection from "../../components/GameDetailsListSection";
import AboutGameSection from "../../components/AboutGameSection";
import SlotGamesSection from "../../components/SlotGamesSection";
import CustomButton from "../../components/Common_UI_Kit/CustomButton";
import ArrowLeftIcon from "../../assets/icons/Arrow-Left";
import FullScreenIcon from "../../assets/icons/Full-Screen";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginContext } from "context/context";
import appConfig from "config/app.config";

const translatedGames =[
  "Vampires Lair",
  "Gladiator Colessium",
  "Splendid Suleyman",
  "Nordic Raiders",
  "Jewels of Wizard",
  "Cosmic Crazies",
  "Jelly Bliss",
  "Drunkie Monkey",
  "Cake Master",
  "Wonderland Grove"
]

const SlotGamePlayPage = () => {
  const elementRef = useRef(null);

  const handleFullScreen = () => {
    if (elementRef.current) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        elementRef.current.requestFullscreen();
      }
    }
  };

  const navigate = useNavigate();
  const location = useLocation()
  const { loginData } = useContext(LoginContext)
  const gameData = location.state

  const handleBackClick = () => {
    navigate(-2);
  }
  const url = `${appConfig.GAME_BASE_URL}${gameData?.launchUrl}?token=${loginData?.accessToken}&currency=${loginData?.currencyCode?.label || 'EUR'}&operator=1&lang=${translatedGames.includes(gameData?.name) ? loginData?.language?.code : 'EN'}`
  const slotGameInfoTextContent = slotGamesInfoTextContent[location.state.launchUrl]

  return (
    <MainLayout>
      <div className="slot-game-play-page">
        <div className="game-img-wrap">
          <div className="game-img-box" ref={elementRef}>
            {/* <img src={slotGamePlayTextContent.imgSrcGame} alt="Image" /> */}
            <iframe src={url} />
          </div>

          <div className="btn-box">
            <CustomButton
              startIcon={<ArrowLeftIcon />}
              label={slotGamePlayTextContent.backBtnText}
              className="back-btn"
              onClick={handleBackClick}
            />
            <CustomButton
              startIcon={<FullScreenIcon />}
              label={slotGamePlayTextContent.fullscreenBtnText}
              className="fullscreen-btn"
              onClick={handleFullScreen}
            />
          </div>
        </div>

        <div className="game-details-section">
          <div className="game-details-wrap">
            <AboutGameSection
              paragraphText={slotGameInfoTextContent.paragraphText}
              listItemTitle={slotGameInfoTextContent.listItemTitle}
              listText={slotGameInfoTextContent.listText}
            />

            <GameDetailsListSection
              showButtons={true}
              gameDetailsList={slotGameInfoTextContent.gameDetailsList}
            />
          </div>
        </div>

        {/* <SlotGamesSection
          sectionHeadingText={slotGameInfoTextContent.headingText}
        /> */}
      </div>
    </MainLayout>
  );
};

export default SlotGamePlayPage;
